var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "global-material-tile" }, [
    _c(
      "div",
      { staticClass: "tile--image-wrapper" },
      [
        _c(
          "a",
          {
            staticClass: "tile--link",
            attrs: { href: _vm.entity.detail_link || _vm.entity.href },
            on: {
              click: function ($event) {
                return _vm.onClick($event)
              },
            },
          },
          [
            _vm.entity.image_src
              ? _c("img", {
                  staticClass: "tile--image img-fluid",
                  attrs: { src: _vm.entity.image_src },
                })
              : _vm._e(),
          ]
        ),
        _vm._v(" "),
        _vm.entity.three_viewer_config
          ? _c("span", {
              staticClass:
                "geometry-viewer geometry-viewer--available open-three-d",
              attrs: {
                "data-decor": _vm.entity.three_viewer_config.decor,
                "data-structure": _vm.entity.three_viewer_config.structure,
              },
            })
          : _vm._e(),
        _vm._v(" "),
        _vm._t("image-wrapper"),
      ],
      2
    ),
    _vm._v(" "),
    _c(
      "div",
      { staticClass: "content-wrapper" },
      [
        _c("div", { staticClass: "tile-content" }, [
          _vm.showWishlist && _vm.wishlistId
            ? _c("span", {
                staticClass:
                  "wish-list link link--secondary icon--small icon--before",
                class: {
                  "icon--wishlist-empty": _vm.inWishlist !== true,
                  "icon--wishlist-filled": _vm.inWishlist,
                },
                attrs: { "data-pid": _vm.wishlistId },
                on: { click: _vm.onWishBtnClick },
              })
            : _vm._e(),
          _vm._v(" "),
          _c(
            "a",
            {
              staticClass: "tile--link",
              attrs: { href: _vm.entity.detail_link || _vm.entity.href },
              on: {
                click: function ($event) {
                  return _vm.onClick($event)
                },
              },
            },
            [
              _vm.entity.title
                ? _c("p", { staticClass: "tile--title" }, [
                    _c("b", [_vm._v(_vm._s(_vm.entity.title))]),
                    _vm._v(" " + _vm._s(_vm.entity.titlesuffix)),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.entity.subtitle
                ? _c("p", { staticClass: "tile--subtitle" }, [
                    _vm._v(_vm._s(_vm.entity.subtitle)),
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.entity.subsubtitle
                ? _c("p", { staticClass: "tile--subtitle" }, [
                    _vm._v(_vm._s(_vm.entity.subsubtitle)),
                  ])
                : _vm._e(),
            ]
          ),
        ]),
        _vm._v(" "),
        _vm.showCart && _vm.entity.order_pid
          ? _c("div", { staticClass: "button-wrapper bottom left" }, [
              _c(
                "button",
                {
                  staticClass:
                    "button button--secondary icon--before icon--shop",
                  class: {
                    "cart-available": _vm.inCart !== true,
                    inactive: _vm.inCart,
                    "cart-added": _vm.inCart,
                  },
                  attrs: {
                    disabled: _vm.inCart,
                    "data-pid": _vm.entity.order_pid,
                    "data-title": _vm.entity.title,
                    "data-titlesuffix": _vm.entity.titlesuffix,
                    "data-subtitle": _vm.entity.subtitle,
                    "data-subsubtitle": _vm.entity.subsubtitle,
                  },
                  on: { click: _vm.onCartBtnClick },
                },
                [
                  _c("span", { staticClass: "cart-text--available" }, [
                    _vm._v(_vm._s(_vm.labelCartBtn)),
                  ]),
                  _vm._v(" "),
                  _c("span", { staticClass: "cart-text--added" }, [
                    _vm._v(_vm._s(_vm.labelCartBtnAdded)),
                  ]),
                ]
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _vm._t("content-wrapper"),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }